"use client";

import { c as _c } from "react/compiler-runtime";
import { IconImac } from "central-icons/IconImac";
import { IconMoon } from "central-icons/IconMoon";
import { IconSun } from "central-icons/IconSun";
import { useTheme } from "next-themes";
import { SegmentedControl } from "@/components/ui/segmented-control";
import { useHydrated } from "@/hooks/use-hydrated";
const THEMES = [{
  icon: IconSun,
  label: "Light theme",
  value: "light"
}, {
  icon: IconMoon,
  label: "Dark theme",
  value: "dark"
}, {
  icon: IconImac,
  label: "System theme",
  value: "system"
}] as const;
type Theme = (typeof THEMES)[number]["value"];
const isTheme = (value: string | undefined): value is Theme => THEMES.some(option => option.value === value);
export function ThemeToggle() {
  const $ = _c(7);
  const {
    theme,
    setTheme
  } = useTheme();
  const hydrated = useHydrated();
  const t0 = !hydrated;
  let t1;
  if ($[0] !== hydrated || $[1] !== theme) {
    t1 = hydrated && isTheme(theme) ? theme : null;
    $[0] = hydrated;
    $[1] = theme;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== setTheme || $[4] !== t0 || $[5] !== t1) {
    t2 = <SegmentedControl aria-label="Theme" disabled={t0} onValueChange={setTheme} options={THEMES} value={t1} variant="icon" />;
    $[3] = setTheme;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}